import FormTitle from '@core/components/FormTitle';
import { Grid } from '@material-ui/core';
import { AnexoDropzone } from 'app/components/Anexo';
import { contratoApi } from 'app/services/api/contratoApi';
import React from 'react';

const AnexoContrato = ({ values, handleChange }) => {
  const handleUpload = (onChange) => {
    return (e) => {
      const files = e.target.value || [];
      const arquivos = [];
      files
        .filter((arquivo) => arquivo.id !== undefined)
        .forEach((element) => {
          arquivos.push(element);
        });

      files
        .filter((file) => !file.id)
        .forEach(async (file) => {
          const formData = new FormData();
          formData.append('arquivo', file);

          const resp = await contratoApi().uploadAnexo(formData);
          arquivos.push({ ...resp.data, size: file.size });
          onChange({ target: { id: 'anexos', value: arquivos } });
        });
    };
  };

  return (
    <>
      <FormTitle title="Anexo de documentos" />
      <Grid container spacing={3} className="mt-16 mb-16">
        <Grid item xs={12} style={{ marginBottom: '50px' }}>
          <AnexoDropzone
            id="anexos"
            maxFiles={10}
            msgErroMaxSizeFiles="É permitido anexar apenas 10 arquivos de 5MB cada."
            onDropFile={handleUpload(handleChange)}
            onRemove={(file) => {
              const anexos = values?.anexos.filter((a) => a.id !== file.id);
              handleChange({ target: { id: 'anexos', value: anexos } });
            }}
            files={values?.anexos}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AnexoContrato;
